import Request from './request'

const DeviceSku = {
  getDeviceSku(params, callback) {
    Request.get('device-sku/index', params).then(callback).catch(this.bad_answer)
  },
  getDeviceSkuInfo(id, callback) {
    Request.get('device-sku/' + id).then(callback).catch(this.bad_answer)
  },
  putDeviceSku(id, params, callback) {
    Request.put('device-sku/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}
export default DeviceSku
